/** W8 GOT Farmer Master (legacy QCS p152): only [Add] is documented. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotFarmerMasterPage } from "@/features/got/components/masters-pages";

export const Route = createFileRoute("/_app/masters/got-farmers")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.locations")) throw redirect({ to: "/" });
  },
  component: GotFarmerMasterPage,
});
